export const browserStorage =
  import.meta.env.VITE_BROWSER_STORAGE === 'localStorage'
    ? window.localStorage
    : window.sessionStorage;
